export default {
  content: {
    class: [
      // Spacing
      'p-0',

      // Shape
      'border-0',

      // Color
      'text-secondary-700 dark:text-white/80',
      'bg-secondary-0 dark:bg-secondary-800'
    ]
  },
  grid: {
    class: [
      // flex
      'flex flex-wrap',

      // Spacing
      'ml-0 mr-0 mt-0',

      // Color
      'bg-secondary-0 dark:bg-secondary-800'
    ]
  },
  header: {
    class: [
      'font-bold',

      // Spacing
      'p-4',

      // Color
      'text-secondary-800 dark:text-white/80',
      'bg-secondary-50 dark:bg-secondary-800',
      'border-secondary-200 dark:border-secondary-700 border-y'
    ]
  }
};
